/**
 * GA4 loader — no-op if REACT_APP_GA4_ID is not set.
 * Safe to call multiple times; will only inject once.
 */
let _loaded = false;

export function initGA4() {
    if (_loaded) return;
    const id = process.env.REACT_APP_GA4_ID;
    if (!id || !/^G-[A-Z0-9]+$/i.test(id)) return;

    _loaded = true;
    // Inject gtag script
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", id, { anonymize_ip: true });
}

export function gaEvent(name, params) {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        try { window.gtag("event", name, params || {}); } catch (_e) { /* ignore */ }
    }
}
